import { render, staticRenderFns } from "./CatalogFilterSortBar.vue?vue&type=template&id=8b6b29d2"
import script from "./CatalogFilterSortBar.vue?vue&type=script&lang=ts"
export * from "./CatalogFilterSortBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports